module.exports = __webpack_public_path__ + "img/img_tutorial_selfie.5cbf0cf9.svg";